export default __webpack_public_path__ + "static/404-astronaut-f88308050cf015ce54781e46f9fd8517.svg";